<script setup lang="ts">
setPageTitle(PageMeta.Categories.Preview.Title)
definePage({ meta: PageMeta.Categories.Preview.Meta })

import ProductCategoryPreviewPage from '@/views/apps/product-categories/preview/ProductCategoryPreviewPage.vue'

const route = useRoute()
const routeParams = route.params as Record<string, string | undefined>
const categoryGuid = computed(() => routeParams.guid as string)

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalProductCategoriesMenu />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <ProductCategoryPreviewPage :category-g-u-i-d="categoryGuid" />
      </VCol>
    </VRow>
  </section>
</template>
